module.exports = __webpack_public_path__ + "media/images/icons/outlined/dribbble-2e31cdfac1091923b8f53644c17ad8ad.svg";